<template>
    <template v-if="currentStep !== VERIFY_STATUSES.approved">
        <div class="pb-4 text-xs text-gray-280 dark:text-gray-190">
            Add a card to complete your plan setup
        </div>

        <div class="p-3 flex max-mob:flex-col items-center gap-y-3 bg-purple-60 dark:bg-blue-770 rounded-custom">
            <div class="text-xs text-gray-370 dark:text-white">
                Press Start to add your card details. You will be redirected to Stripe to complete the process
            </div>

            <PrimaryBtn
                class="min-w-30 max-mob:w-full"
                :loading="loading"
                height="h-10"
                @click="onStartStripe"
            >
                Start
            </PrimaryBtn>
        </div>
    </template>

    <template v-else>
        <div class="pb-3 text-xs font-medium text-gray-370 dark:text-white">
            Card Details
        </div>

        <SuccessBlock
            height="h-auto"
            messages="Your card successfully added!"
        />
    </template>
</template>

<script setup>
import {
    ref, onUnmounted, watch, computed, onMounted,
} from 'vue'

import PrimaryBtn from '@/components/buttons/PrimaryBtn.vue'
import SuccessBlock from '@/components/successBlock/SuccessBlock.vue'

import { useVerificationUserStore } from '@/store/call-tracking/verificationUserStore'

import { VERIFY_STATUSES } from '@/constants/verifyStatuses'

const verificationUserStore = useVerificationUserStore()

const currentStep = ref(VERIFY_STATUSES.active)

const statusInterval = ref(null)

const stripeStatus = computed(() => verificationUserStore.stripeStatus)
const loading = computed(() => VERIFY_STATUSES.reviewing === stripeStatus.value)

onMounted(() => {
    if (verificationUserStore.stripeIsVerify) {
        changeStep(VERIFY_STATUSES.approved)

        return
    }

    setStatusInterval()
})

function changeStep(newStep) {
    currentStep.value = newStep
}

async function onStartStripe() {
    const { success } = await verificationUserStore.goToStripeVerification()

    if (success) {
        window.open(verificationUserStore.stripeUrl, '_blank')
    }
}

function setStatusInterval() {
    clearInterval(statusInterval.value)

    verificationUserStore.goToCheckVerificationCardStatus()

    statusInterval.value = setInterval(() => {
        verificationUserStore.goToCheckVerificationCardStatus()
    }, 10000)
}

watch(stripeStatus, (stripeStatus) => {
    if (stripeStatus === VERIFY_STATUSES.approved) {
        changeStep(VERIFY_STATUSES.approved)
        verificationUserStore.setStripeIsVerify(true)
        clearInterval(statusInterval.value)
    }
}, { immediate: true })

onUnmounted(() => {
    clearInterval(statusInterval.value)
})
</script>
